module.exports = __webpack_public_path__ + "img/img0.20259193.jpg";